import styles from './hoverpicture.css'

export type HoverPictureProps = {
  description: string
  image: number
  name: string
}

const HoverPicture = ({ image, description, name }: HoverPictureProps): JSX.Element => (
  <div className={styles.hoverPicture} style={{ backgroundImage: `url("/is/${image}/fill-1600x594/")` }}>
    <span className={styles.text}>
      <span className={styles.name}>{name}</span>
      <span className={styles.description}>{description}</span>
    </span>
  </div>
)

export default HoverPicture
